module.exports = __webpack_public_path__ + "./Ting-YuPhoto_b794400b259af69d39d40d91a6d8b2a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/Ting-YuPhoto.png
// module id = 509
// module chunks = 0